import { lazy, Suspense } from 'react';
import Navbar from '../home/components/Navbar';
import Hero from './components/Hero';
import SEOJsonLd from '../../components/feature/SEOJsonLd';

const BrandBelief = lazy(() => import('./components/BrandBelief'));
const Mission     = lazy(() => import('./components/Mission'));
const CoreValues  = lazy(() => import('./components/CoreValues'));
const ClosingCTA  = lazy(() => import('./components/ClosingCTA'));
const Footer      = lazy(() => import('../home/components/Footer'));

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vetuvia.com';

function SectionFallback() {
  return <div className="w-full py-20 bg-white" aria-hidden="true" />;
}

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOJsonLd
        title="About Vetuvia – Honoring Great Veterinarians | Mission & Values"
        description="Vetuvia was built to honor great veterinarians and expand their impact. Learn about our mission to make veterinary care more accessible, our core values, and why we believe passionate veterinarians can change the world."
        keywords="about Vetuvia, veterinary platform mission, veterinarian values, veterinary care access, veterinarian-led services"
        canonical={`${siteUrl}/about`}
        ogImage="https://static.readdy.ai/image/f30444846e2254d95b405efc135ce378/b4d09c4f03ec4a157d9695deb6f4dc19.png"
        schemaType="AboutPage"
      />
      <Navbar />
      <Hero />
      <Suspense fallback={<SectionFallback />}>
        <BrandBelief />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Mission />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <CoreValues />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <ClosingCTA />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Footer />
      </Suspense>
    </div>
  );
}
